const addTopBillersQueries = require('../../queries/configs/TopBillers');

module.exports = addTopBillersQueries(function ({ baseUrl }) {
  return ({
    baseUrl: `${baseUrl}/topBillers`,
  })
});
